module.exports = __webpack_public_path__ + "src/main/main.tpl-f146b4e5a9fb1e45d2d561926d59f6c2.html";


//////////////////
// WEBPACK FOOTER
// ./src/main/main.tpl.html
// module id = 69
// module chunks = 0